<template>
  <CarnetsList/>
</template>
<script>
import CarnetsList from '@/components/modules/admin/carnets/list'
export default {
  name: 'adminCarnets',
  components: {
    CarnetsList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/carnets/list.vue